export type CashPinIntent = { method: string; path: string; body?: unknown };
export type CashPinChallenge = { branchId: string; intent: CashPinIntent; workspaceId: string };
type Handler = (challenge: CashPinChallenge) => Promise<void>;
let handler: Handler | undefined;

/** In-memory bridge only. No PIN, proof, request, or intent is persisted. */
export function installCashPinGate(next: Handler) {
  handler = next;
  return () => { if (handler === next) handler = undefined; };
}
export async function requestCashPin(challenge: CashPinChallenge) {
  if (!handler) throw new Error("Responsible manager confirmation is unavailable. Please retry.");
  await handler(challenge);
}
export function cashPinRequired(payload: unknown): string | null {
  const details = (payload as { details?: { code?: string; branchId?: string } } | null)?.details;
  return details?.code === "CASH_PIN_REQUIRED" ? details.branchId || "" : null;
}